import { WeatherLocation, CustomWeatherDateRange } from '@interfaces/weather.interface';


export const DEFAULT_WEATHER_LOCATION: WeatherLocation = {
    name: 'Manila, Philippines',
    latitude: 14.5995,
    longitude: 120.9842,
    timezone: 'Asia/Manila'
};

export const CUSTOM_WEATHER_LOCATIONS: CustomWeatherDateRange[] = [
    {
        startDate: '2025-06-07',
        endDate: '2025-06-11',
        location: {
            name: 'Boracay, Philippines',
            latitude: 11.9674,
            longitude: 121.9248,
            timezone: 'Asia/Manila'
        }
    },
    {
        startDate: '2026-03-20',
        endDate: '2026-03-26',
        location: {
            name: 'Seoul, South Korea',
            latitude: 37.532600,
            longitude: 127.024612,
            timezone: 'Asia/Seoul'
        }
    },
    {
        startDate: '2026-03-27',
        endDate: '2026-03-28',
        location: {
            name: 'Busan, South Korea',
            latitude: 35.1800,
            longitude: 129.0750,
            timezone: 'Asia/Seoul'
        }
    },
    {
        startDate: '2026-03-29',
        endDate: '2026-03-30',
        location: {
            name: 'Seoul, South Korea',
            latitude: 37.532600,
            longitude: 127.024612,
            timezone: 'Asia/Seoul'
        }
    }
];
